export default __webpack_public_path__ + "static/screenFifthSectionRuBig-04f65b1c0392f7e365bd09217a365af6.webp";